export const getSPUDBulkUpdateEnvironment = (): string|null|undefined => {
  return window.SPUD_BULK_UPDATE_ENV
}
